// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RoundButton Styles */

.scl--web-component-round-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 139px;
  height: 40px;
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 16px;
  gap: 11px;
  opacity: 1;
  border-radius: 20px;
  border: 1.5px solid #797979;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.scl--web-component-round-button:hover {
  background: #FFFFFF1A;
  border: 1px solid #fff;
}

.scl--web-component-round-button-text {
  font-family: var(--primary-font);
  font-weight:400;
  font-style:  normal;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color:   #FFFFFF;
}

.scl--web-component-round-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #FFFFFFCC;
}

.scl--web-component-round-button-icon svg {
  width: 16px;
  height: 16px;
}

.scl--web-component-round-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.scl--web-component-round-button.disabled:hover {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/button/round-button/css/roundButton.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* RoundButton Styles */\n\n.scl--web-component-round-button {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-width: 139px;\n  height: 40px;\n  padding-top: 16px;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-bottom: 16px;\n  gap: 11px;\n  opacity: 1;\n  border-radius: 20px;\n  border: 1.5px solid #797979;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.scl--web-component-round-button:hover {\n  background: #FFFFFF1A;\n  border: 1px solid #fff;\n}\n\n.scl--web-component-round-button-text {\n  font-family: var(--primary-font);\n  font-weight:400;\n  font-style:  normal;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  text-align: center;\n  color:   #FFFFFF;\n}\n\n.scl--web-component-round-button-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #FFFFFFCC;\n}\n\n.scl--web-component-round-button-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.scl--web-component-round-button.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.scl--web-component-round-button.disabled:hover {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
